export default __webpack_public_path__ + "src/assets/lend-logo.0d39add5e86fb2a5de0bac704ad4c7fb.png";